export default __webpack_public_path__ + "static/media/kuo_avatar.e6d35f15.png";